import { env } from "../env";

/** Extra `sendUserOperation` options that ask Coinbase's Paymaster to sponsor gas, or nothing when
 *  sponsorship isn't enabled for this deployment. Spread into every user-operation call.
 *
 *  Off unless `VITE_USE_CDP_PAYMASTER=true` is baked into the build. Turn it on only after the
 *  Paymaster is configured in the CDP Portal (allowlist the escrow + USDC functions the app calls,
 *  with per-user and global limits) — with sponsorship requested but unconfigured, every purchase
 *  would fail instead of just needing a little ETH. */
export function sponsorshipOptions(): { useCdpPaymaster?: true } {
  return env.VITE_USE_CDP_PAYMASTER === "true" ? { useCdpPaymaster: true } : {};
}
